import React from "react";
import "./Clients.css";

// Import images
import c1 from "../assets/c1.jpg";
import c2 from "../assets/c2.jpg";
import c3 from "../assets/c3.jpg";
import c4 from "../assets/c4.jpg";
import c5 from "../assets/c5.jpg";
import c6 from "../assets/c6.jpg";
import c7 from "../assets/c7.jpg";
import c8 from "../assets/c8.jpg";
import c9 from "../assets/c9.jpg";
import c10 from "../assets/c10.jpg";
import c11 from "../assets/c11.jpg";
import c12 from "../assets/c12.jpg";
import c13 from "../assets/c13.jpg";
import c14 from "../assets/c14.jpg";
import c15 from "../assets/c15.jpg";
import c16 from "../assets/c16.jpg";
import c17 from "../assets/c17.jpg";
import c18 from "../assets/c18.jpg";
import c19 from "../assets/c19.jpg";

const logos = [
  c1,
  c2,
  c3,
  c4,
  c5,
  c8,
  c9,
  c10,
  c12,
  c13,
  c14,
  c15,
  c16,
  c17,
  c18,
  c19,
];

const Clients = () => {
  return (
    <div className="clients-section" id="clients">
      <h2 className="clients-title">Our Clients</h2>

      <div className="logo-slider">
        <div className="logo-track">
          {logos.map((logo, index) => (
            <div className="logo-slide" key={index}>
              <img src={logo} alt={`Client ${index}`} />
            </div>
          ))}

          {/* Duplicate set for infinite scroll */}
          {logos.map((logo, index) => (
            <div className="logo-slide" key={`dup-${index}`}>
              <img src={logo} alt={`Client duplicate ${index}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Clients;
